import { useQuery } from 'react-query';
import config from 'config';
import { useGameStore } from '../hooks/useGameStore';
import apiClient from '../../../helpers/apiClient';

async function getSettings() {
  return (await apiClient().get('/v1/deposit/settings', { params: { asset: config.asset } })).data;
}

export default function useDepositSettings(enabled) {
  const { data: settings = {}, isLoading } = useQuery(['deposit', 'settings'], getSettings, {
    onSuccess: () => useGameStore.getState().setBettingDisabled(false),
    refetchOnMount: false,
    enabled,
  });

  return { isLoading, receiver: settings.receiver };
}
useDepositSettings.propTypes = {};
useDepositSettings.defaultProps = {};
